import { useFeedbackConfigs } from '@/hooks/useSwr';

export const useSortedFeedbackConfigs = () => {
  const feedbackConfigs = useFeedbackConfigs();
  const correctness = feedbackConfigs.data?.find(
    (i) =>
      i.feedback_key === 'correctness' && i.feedback_config.type !== 'freeform'
  ) ?? {
    feedback_key: 'correctness',
    feedback_config: {
      type: 'continuous',
      min: 0,
      max: 1,
      categories: [{ value: 0 }, { value: 1 }],
    },
  };

  // move the correctness feedback to the front
  const configs = feedbackConfigs.data?.filter(
    (i) => i.feedback_key !== 'correctness'
  );
  configs?.unshift(correctness);

  return configs;
};
